import { render } from "./emailReceivedIcon.vue?vue&type=template&id=006f7d06"
const script = {}

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__